import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { CvpMenu } from "../../../generic-components/menu/CvpMenu";
import { completeMenuItem } from "../MenuItems/completeMenuItem";
import { useNavItems } from "../MenuItems/useNavItems";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";

export const MobileNav = withWSErrorContainer(
  observer(() => {
    const navItems = useNavItems().navItems;

    return (
      <StyledMobMenu
        className="cvp-mob-menu"
        model={navItems.map((item) => completeMenuItem(item))}
      />
    );
  })
);

const StyledMobMenu = styled(CvpMenu)`
  &.cvp-mob-menu {
    width: 100%;
    padding-top: 3rem;
    border-color: transparent;

    .p-menuitem-link {
      padding: 1rem 1rem;
      font-weight: 500;
      font-size: 1rem;
    }

    .p-menuitem-icon {
      width: 2.4rem;
      height: 2.4rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      background: var(--primary-50-relative);
      border-radius: 50%;
      color: var(--surface-600);
    }
    .p-menuitem-text {
      font-size: 0.9rem;
      font-weight: 500;
    }
  }
`;
